'use strict';

var TEXT_CORRECT_VERTICAL_POSITION = '53';
var TRAIL_CORRECT_STROKE_WIDTH = '1.25';
var DEFAULT_TIME_S = 60;
var STROKE_WIDTH = 3.33;
var TIME_STEP_MS = 100;
function formatTimeLeft(timeLeft) {
    if (timeLeft <= 0) {
        return '0:00';
    }
    var numOfMinutesLeft = Math.floor(timeLeft / 60);
    var numOfSecondsLeft = timeLeft % 60;
    var secondsStr = "".concat(numOfSecondsLeft < 10 ? '0' : '').concat(numOfSecondsLeft);
    return "".concat(numOfMinutesLeft, ":").concat(secondsStr);
}
function convertMSToS(ms) {
    return ms / 1000;
}
function fixStyles(textClassName, trailClassName) {
    document.querySelector(".".concat(textClassName))
        .setAttribute('y', TEXT_CORRECT_VERTICAL_POSITION);
    document.querySelector(".".concat(trailClassName))
        .setAttribute('stroke-width', TRAIL_CORRECT_STROKE_WIDTH);
}

exports.DEFAULT_TIME_S = DEFAULT_TIME_S;
exports.STROKE_WIDTH = STROKE_WIDTH;
exports.TIME_STEP_MS = TIME_STEP_MS;
exports.convertMSToS = convertMSToS;
exports.fixStyles = fixStyles;
exports.formatTimeLeft = formatTimeLeft;
